import each from './each';
import notExisty from './notExisty';

// Merge the contents of two or more objects together into the first object
export default function extend(target, ...args) {
   each(args, options => {
      if (notExisty(options)) {
         return;
      }
      each(options, (val, key) => {
         target[key] = val;
      });
   });

   // Return the modified object
   return target;
}
